// TanStack Query cache keys for admin/admins (roles management).
export const adminAdminsKeys = {
  all: ["admin", "admins"] as const,
  roles: () => ["admin", "admins", "roles"] as const,
  roleList: (params: Record<string, unknown>) =>
    ["admin", "admins", "roles", "list", params] as const,
};
